import PropTypes from 'prop-types';

export default PropTypes.shape({
  loading: PropTypes.bool,
  mapUrl: PropTypes.string,
  taxonomy: PropTypes.shape({
    location: PropTypes.shape({
      coordinates: PropTypes.arrayOf(PropTypes.number),
    }),
    name: PropTypes.string,
  }),
  boundingBox: PropTypes.shape({
    north: PropTypes.number,
    south: PropTypes.number,
    east: PropTypes.number,
    west: PropTypes.number,
  }),
  travelContent: PropTypes.shape({
    id: PropTypes.string,
    contentType: PropTypes.string,
    createdAt: PropTypes.number,
    updatedAt: PropTypes.number,
    content: PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      summary: PropTypes.string,
      body: PropTypes.string,
    }),
    media: PropTypes.shape({
      large: PropTypes.string,
      medium: PropTypes.string,
      type: PropTypes.string,
      thumbnail: PropTypes.string,
      full: PropTypes.string,
    }),
  }),
});
